"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callToBookConditionsNovasol = exports.callToBookConditionsUK = void 0;
const today = new Date();
today.setHours(0, 0, 0, 0);
const tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1);
tomorrow.setHours(0, 0, 0, 0);
exports.callToBookConditionsUK = [
    {
        hourValidFrom: 16,
        timeZone: 'Europe/London',
        startDates: [today],
    },
];
exports.callToBookConditionsNovasol = [
    {
        hourValidFrom: 0,
        timeZone: 'Europe/Copenhagen',
        startDates: [today],
    },
    {
        hourValidFrom: 17,
        timeZone: 'Europe/Copenhagen',
        startDates: [tomorrow],
    },
];
//# sourceMappingURL=callToBookConditions.js.map